import type { AdminUser, FlagKey } from './types';

const PATHS: Record<string, string> = {
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM13 13h7v7h-7zM4 13h7v7H4z',
  users: 'M17 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM22 20v-2a4 4 0 0 0-3-3.87M16 3.13A4 4 0 0 1 16 11',
  inbox: 'M4 13h4l1.5 3h5L16 13h4M4 13l2.5-8h11L20 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z',
  spark: 'M13 2 4 14h7l-1 8 9-12h-7z',
  hdd: 'M4 15h16M4 15a2 2 0 0 1-2-2V9l3-6h14l3 6v4a2 2 0 0 1-2 2M4 15v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4M7 19h.01M11 19h.01',
  alert: 'M12 3 2 20h20L12 3zM12 10v4M12 18h.01',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-2.7-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 4.6 15H4a2 2 0 1 1 0-4h.2a1.6 1.6 0 0 0 1.1-2.7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 11 4.6V4a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7H21a2 2 0 1 1 0 4h-.2a1.6 1.6 0 0 0-1.4.9Z',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.3-4.3',
  dots: 'M12 6h.01M12 12h.01M12 18h.01',
  check: 'M5 12l5 5L20 6',
  x: 'M6 6l12 12M18 6 6 18',
  key: 'M15 7a4 4 0 1 1-3.9 5H8v3H5v3H2v-3l6.1-6.1A4 4 0 0 1 15 7Z',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  power: 'M12 3v9M6.5 7a8 8 0 1 0 11 0',
  sliders: 'M4 6h10M18 6h2M4 12h2M10 12h10M4 18h8M16 18h4M14 4v4M6 10v4M12 16v4',
  ban: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM5.6 5.6l12.8 12.8',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z',
  gauge: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 12l4-3M9 16h6',
  coin: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v10M15 9.5c0-1.4-1.3-2-3-2s-3 .6-3 2 1.3 2 3 2 3 .6 3 2-1.3 2-3 2-3-.6-3-2',
  db: 'M12 8c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3ZM4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  cloud: 'M7 18a4 4 0 0 1 0-8 5 5 0 0 1 9.6-1.3A3.5 3.5 0 0 1 18 18H7Z',
  bolt: 'M13 2 4 14h7l-1 8 9-12h-7z',
  fingerprint: 'M12 11a2 2 0 0 0-2 2c0 1 .2 2.5-.5 4M7 12a5 5 0 0 1 8-4M5 15c1-1 1.2-3 1-4M12 11c.3 3 0 6-1 8M16 12c.2 3-.3 5-1 7M19 13c0 3-.4 5-1 6',
};

export function Icon({ name, size = 18, sw, style }: { name: string; size?: number; sw?: number; style?: React.CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={sw ?? 1.9} strokeLinecap="round" strokeLinejoin="round" style={style}>
      <path d={PATHS[name] ?? ''} />
    </svg>
  );
}

export const fmt = {
  tokens(n: number): string {
    if (n >= 1e6) return (n / 1e6).toFixed(n >= 1e7 ? 0 : 2).replace(/\.00$/, '') + 'M';
    if (n >= 1e3) return (n / 1e3).toFixed(n >= 1e5 ? 0 : 1).replace(/\.0$/, '') + 'k';
    return String(n);
  },
  cost(n: number): string { return '£' + n.toFixed(2); },
  mb(n: number): string { return n >= 1024 ? (n / 1024).toFixed(n >= 10240 ? 1 : 2) + ' GB' : n + ' MB'; },
  int(n: number): string { return n.toLocaleString('en-GB'); },
  pct(a: number, b: number): number { return b ? Math.min(999, Math.round(a / b * 100)) : 0; },
};

export function Avatar({ size = 34, hue, initials, dis }: { size?: number; hue: string; initials: string; dis?: boolean }) {
  return (
    <span className={'av' + (dis ? ' dis' : '')}
      style={{ width: size, height: size, background: hue, fontSize: Math.round(size * 0.4) }}>
      {initials}
    </span>
  );
}

export function Badge({ kind = 'mut', dot = true, children }: { kind?: string; dot?: boolean; children: React.ReactNode }) {
  return <span className={'badge ' + kind}>{dot && <span className="d" />}{children}</span>;
}

export function StatusBadge({ status }: { status: string }) {
  const map: Record<string, [string, string]> = { active: ['ok', 'Active'], disabled: ['bad', 'Disabled'], pending: ['warn', 'Pending'] };
  const [k, l] = map[status] ?? ['mut', status];
  return <span className={'badge ' + k}><span className="d" />{l}</span>;
}

export function TierBadge({ tier }: { tier: string }) {
  return tier === 'approved'
    ? <span className="badge info" style={{ textTransform: 'none' }}>Approved</span>
    : <span className="badge acc" style={{ textTransform: 'none' }}>Free tier</span>;
}

export function Meter({ pct, level }: { pct: number; level?: string }) {
  const pc = Math.max(0, pct);
  const lvl = level ?? (pc >= 100 ? 'bad' : pc >= 90 ? 'warn' : 'ok');
  return <div className="meter"><span className={lvl} style={{ width: Math.min(100, pc) + '%' }} /></div>;
}

export function UsageCell({ user }: { user: AdminUser }) {
  const tp = fmt.pct(user.tokens, user.capTokens);
  const cp = fmt.pct(user.cost, user.capCost);
  const worst = Math.max(tp, cp);
  const lvl = worst >= 100 ? 'bad' : worst >= 90 ? 'warn' : 'ok';
  return (
    <div className="usecell">
      <div className="row">
        <span className="v mono">{fmt.cost(user.cost)}</span>
        <span className="cap mono">/ {fmt.cost(user.capCost)}</span>
      </div>
      <Meter pct={cp} level={lvl} />
      <div className="sub">{fmt.tokens(user.tokens)} / {fmt.tokens(user.capTokens)} tokens · {tp}%</div>
    </div>
  );
}

export function FlagDots({ flags }: { flags: FlagKey[]; flagsMeta: Record<FlagKey, { sev: string }> }) {
  if (!flags.length) return <span style={{ color: 'var(--faint)' }}>—</span>;
  return (
    <span className="flagdots">
      {flags.map(f => <span key={f} className={'fd ' + (f === 'rate' || f === 'logins' || f === 'dupe' ? 'bad' : 'warn')} />)}
    </span>
  );
}
